import axios from 'axios';
import toastr from 'toastr';

export const tizeti_asset_active_inactive_users = async (initialState) => {
  try {
    const url = 'https://slot.tizeti.com/geniatechapi/index.php';

    // Create FormData instead of URLSearchParams
    const formData = new FormData();

    // Add each key-value pair to the FormData object
    Object.entries(initialState).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Use formData in the request instead of initialState
    const res = await axios.post(url, formData);
    if (res.data) {
      // console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error(error);
    toastr.error('error fetching data');
  }
};
